/**
 * @generated SignedSource<<41fda70fe72ee1506b3cf64d72913a6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type processDefinitionsTemplateQueryDeleteMutation$variables = {
  ids: ReadonlyArray<string>;
};
export type processDefinitionsTemplateQueryDeleteMutation$data = {
  readonly deleteProcessDefinitions: boolean | null | undefined;
};
export type processDefinitionsTemplateQueryDeleteMutation = {
  response: processDefinitionsTemplateQueryDeleteMutation$data;
  variables: processDefinitionsTemplateQueryDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteProcessDefinitions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionsTemplateQueryDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionsTemplateQueryDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9fbf4615a0dc09424c37907f97dbce24",
    "id": null,
    "metadata": {},
    "name": "processDefinitionsTemplateQueryDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionsTemplateQueryDeleteMutation(\n  $ids: [ID!]!\n) {\n  deleteProcessDefinitions(ids: $ids)\n}\n"
  }
};
})();

(node as any).hash = "2c4fe82360918b57dadf92d636a81400";

export default node;
